exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".upozorenje{\r\n    color: white;\r\n}\r\n\r\n.loading {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-pack: center;\r\n        -ms-flex-pack: center;\r\n            justify-content: center;\r\n}\r\n\r\n.loading::after {\r\n    content: \"\";\r\n    width: 20px;\r\n    height: 20px;\r\n    border: 10px solid #dddddd;\r\n    border-top-color: #eecd12;\r\n    border-radius: 50%;\r\n    -webkit-animation: loading 0.9s ease infinite;\r\n            animation: loading 0.9s ease infinite;\r\n    margin-left: 10px;\r\n}\r\n\r\n@-webkit-keyframes loading {\r\n    to {\r\n        -webkit-transform: rotate(1turn);\r\n                transform: rotate(1turn);\r\n    }\r\n}\r\n\r\n@keyframes loading {\r\n    to {\r\n        -webkit-transform: rotate(1turn);\r\n                transform: rotate(1turn);\r\n    }\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/TomislavS/Projekti/31-Holspico-VirtualnaUcionica/VirtualnaUcionica-Web/src/app/pages/virtualna-ucionica/ucionica-popis/ucionica-popis.component.css
// module id = ../../../../../src/app/pages/virtualna-ucionica/ucionica-popis/ucionica-popis.component.css
// module chunks = main